function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 28 26"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.6 21.6 17 15c1.2-1.6 1.8-3.5 1.8-5.5 0-5.2-4.2-9.4-9.4-9.4C6.9 0 4.5 1 2.7 2.7S0 6.9 0 9.4c0 5.2 4.2 9.4 9.4 9.4 2 0 3.9-.6 5.6-1.8l6.6 6.6c.4.4.9.5 1.4.4s.9-.5 1-1c.1-.6-.1-1.1-.4-1.4zM9.4 16.9c-4.2 0-7.5-3.4-7.5-7.6 0-2 .8-3.9 2.2-5.3s3.3-2.2 5.3-2.2c4.2 0 7.5 3.4 7.5 7.6 0 2-.8 3.9-2.2 5.3s-3.3 2.2-5.3 2.2z",
    style: {
      stroke: "#fff",
      fill: "#fff"
    },
    transform: "translate(2 1)"
  }));
};
export default SvgSearch;